export default {
    getList: {
        getDealingWorkList: async function (params) {
            let option = {
                url: '/api/v1/worksheet/updating',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminDealingWorkList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        returnWork: async function (params) {
            let option = {
                url: '/api/v1/worksheet/assign',
                type: 'post',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminDealingWorkList.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
    }
}